import { type AvailableContextMenuModeType, MenuContextCustomActions } from '../MenuContextCustomActions';
import { menuContext } from './MenuContextStore';
import { get } from 'svelte/store';

export class MenuContextFactory {
    static set(menu: MenuContextCustomActions, open: boolean = false, menuMode: AvailableContextMenuModeType = 'menu') {
        // get deep copy of menu object
        let menuCopy = new MenuContextCustomActions();
        menuCopy.init([...menu.getActionsForContextMenu()]);
        if (open) {
            menuCopy.open(menuMode);
        }
        menuContext.set(menuCopy);
    }

    static get() {
        return get(menuContext);
    }

    static setCoords(x: number, y: number) {
        get(menuContext).setCoords(x, y);
        menuContext.set(get(menuContext));
    }

    static open(menuMode: AvailableContextMenuModeType = 'menu') {
        get(menuContext).open(menuMode);
    }

    static close() {
        get(menuContext).isOpen = false;
    }
}
